<template>
  <div>
    <div>
      <b-tabs pills card class="righttop navbut">
        <b-tab title="Overview" active no-body>
          <Overview />
        </b-tab>
        <b-tab title="Posts" v-if="userData.role !== 'volunteer'"
          ><Posts
        /></b-tab>
        <b-tab title="All Courses" v-if="userData.role !== 'volunteer'"
          ><Courses
        /></b-tab>
        <b-tab title="Update Profile"><Userprofile /></b-tab>
        <b-tab title="Refer &amp;  Earn" v-if="userData.role !== 'volunteer'">
          <Earn
        /></b-tab>
        <b-tab title="Subscription" v-if="userData.role !== 'volunteer'"
          ><SubscriptionTab
        /></b-tab>
        <b-tab title="BookMarks" v-if="userData.role !== 'volunteer'"
          ><BookMarks
        /></b-tab>
        <b-tab title="Bookings" v-if="userData.role === 'volunteer'"
          ><Bookings
        /></b-tab>
        <!-- <b-tab title="Events"></b-tab>
        <b-tab title="Settings"></b-tab> -->
      </b-tabs>
    </div>
  </div>
</template>

<script>
import Overview from "./tabs/OverviewTab.vue";
import Courses from "./tabs/CoursesTab.vue";
import Posts from "./tabs/Posts";
import Userprofile from "./tabs/userprofileTab.vue";
import Earn from "./tabs/components/Earn.vue";
import SubscriptionTab from "./tabs/SubscriptionTab.vue";
import BookMarks from "./tabs/BookMarks.vue";
import Bookings from "./tabs/Bookings.vue";
import { mapState } from "vuex";

export default {
  components: {
    Overview,
    BookMarks,
    Courses,
    Posts,
    Userprofile,
    Earn,
    SubscriptionTab,
    Bookings,
  },
  computed: {
    ...mapState("auth", ["userData"]),
  },
};
</script>
<style>
.nav-pills .nav-item {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  padding-right: 6px !important;
}
</style>
